import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByNodeId, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { cardStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import parse, { HTMLReactParserOptions } from "html-react-parser";
import Icon from "@insite/mobius/Icon";
import Check from "@insite/mobius/Icons/Check";

interface Matrics {
    fields: {
        matricsTitle: string;
        matricsValue: string;
        matricsValueColor: string;
        matricsPercentage: string;
        matricsColor: string;
    }
}

interface InfoCardModel {
    fields: {
        sectionTitle: string;
        textColor: string;
        textSize: string;
        primaryBackground: string;
        subTitle: string;
        subtitleColor: string;
        matrics: Matrics[];
    };
}

const enum fields {
    matricsCards = "matricsCards",
    sectionTitle = "sectionTitle",
    subTitle = "subTitle",
    textColor="textColor",
    textSize="textSize",
    primaryBackground="primaryBackground",
    infoCardTitle = "infoCardTitle",
    primarySectionWidth = "primarySectionWidth",
    titleColor = "titleColor",
    subtitleColor = "subtitleColor",
    matrics = "matrics",
    matricsTitle = "matricsTitle",
    matricsValue = "matricsValue",
    matricsValueColor = "matricsValueColor",
    matricsPercentage = "matricsPercentage",
    matricsColor = "matricsColor"

}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.matricsCards]: InfoCardModel[];
        infoCardTitle: string;
        titleColor: string;
        primarySectionWidth: GridWidths;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { matricsCards, infoCardTitle, titleColor, primarySectionWidth },
    } = ownProps;
    const mappedInfoCards = [];
    for (const card of matricsCards) {
        mappedInfoCards.push(card.fields);
    }
    return {
        infoCardTitle,
        titleColor,
        primarySectionWidth,
        mappedInfoCards,
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface IInfoCardsStyles {
    container?: GridContainerProps;
    infoCard?: GridItemProps;
    customflyImgWrapper?: InjectableCss;
    customDescriptionText?: TypographyPresentationProps;
    customFlyTitle?: TypographyPresentationProps;
    infocardcontainer?: InjectableCss;
    infocardWraper?: InjectableCss;
    buttonStyle?: LinkPresentationProps;
    infoCardTitle?: InjectableCss;
    sectionWrapper?: InjectableCss;
    textWrapper?: InjectableCss;
    footerSectionWrapper?: InjectableCss;
    footerBtn?: ButtonPresentationProps;
    textIconWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sectionTitleWrapper?: InjectableCss;
    infoCardWrapper?: InjectableCss;
    sectionTitle?: InjectableCss;
    iconSubTitle?: InjectableCss;
    sectionTitleGrid?: GridItemProps;
    secondaryIcon?: InjectableCss;
    mappedInfoCardsWrapper?: GridItemProps;
    subTitle?: InjectableCss;
}

export const infoCardsStyles: IInfoCardsStyles = {
    infoCardTitle: {
        css: css`
            [data-test-selector="infoCardTitle"] {
            font-size: 1.7rem;
            font-weight: 500;
            margin: 20px 0px;
            margin-bottom: 20px;
            font-family: "Barlow-Regular";
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 0px;
                            margin: 0px;
                            margin-bottom: 10px;
                            margin-top: 20px;
                        `,
                        css`
                            padding-left: 0px;
                            margin: 0px;
                            margin-bottom: 10px;
                            margin-top: 20px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    infocardcontainer: {
        css: css`
            max-width: 1300px;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                        `,
                        css`
                            max-width: 100% !important;
                        `,
                        css`
                            max-width: 720px !important;
                        `,
                        css`
                            max-width: 960px !important;
                        `,
                        css`
                            max-width: 1300px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    container: {
        gap: 38,
        css: css`
            align-items: center;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                            padding: 0px;
                        `,
                        css`
                            max-width: 100% !important;
                            padding: 0px;
                        `,
                        css`
                            max-width: 720px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 960px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 1300px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    sectionTitleGrid:{
        css:css`
        [data-test-selector="customFlyTitle"]{
            font-size: 1.6rem;
            letter-spacing: 0;
            margin: 0px;
            font-weight: 600;
            font-family: 'Barlow-Regular';
            line-height: inherit;
            margin-bottom: 20px;
            min-height: 48px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          font-size: 1.2rem !important;
                        `,
                        css`
                          font-size: 1.2rem !important;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
            [data-test-selector="sectionTitleWrapper"]{
            width: 100%;
            display: flex;
            justify-content: left;
            align-items: left;
            height: 100%;
            padding: 20px;
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          padding: 15px;
                        `,
                        css`
                          padding: 15px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          padding-bottom: 0px;   
                        `,
                        css`
                          padding-bottom: 0px; 
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    },
    infoCard: {
        css: css`
            display: flex;
            flex-direction: column;
            min-height: 200px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          padding-top: 0px;   
                        `,
                        css`
                          padding-top: 0px; 
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    infocardWraper: {
        css: css`
            border-bottom: 5px solid ${getColor("primary.main")};
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            box-shadow: 1px 7px 11px 0px rgb(0 0 0 / 13%);
        `,
    },
    customflyImgWrapper: {
        css: css`
            box-sizing: border-box;
            width: 100%;
            height: 180px;
            overflow: hidden;
            div[class^="LazyImageStyle"] {
                width: 100%;
                height: auto;
            }
            img {
                height: 180px;
                width: 100%;
                object-fit: cover;
            }
        `,
    },
    customDescriptionText: {
        variant: "p",
        css: css`
            color: #33333a;
            font-size: 0.9rem;
            font-weight: 600;
            letter-spacing: 0;
            line-height: inherit;
            font-family: 'Barlow-Regular';
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        `,
    },
    buttonStyle: {
        css: css`
            span {
                background-color: transparent !important;
                color: ${getColor("primary.main")} !important;
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 2px;
                line-height: normal;
                text-transform: uppercase;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    sectionWrapper:{
        css:css`
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            padding: 7px 15px;
        `
    },
    textWrapper:{
        css:css`
            display: flex;
            flex-grow: 0;
            text-align: right;
            padding: 0px;
            box-sizing: content-box;
            justify-content: left;
            position: relative;
            width: 100%;
            &::before{
                content: "";
                width: 1px;
                height: 10px;
                background: gray;
                position: absolute;
                bottom: -10px;
            }
            &::after{
                content: "";
                width: 1px;
                height: 10px;
                background: gray;
                position: absolute;
                top: -10px;
            }

        `
    },
    footerSectionWrapper:{
        css:css`
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 4rem;
        `
    },
    footerBtn:{
        css:css`
            padding: 10px 15px;
            text-transform: uppercase;
            font-family: 'Barlow-Regular';
        `
    },
    textIconWrapper:{
        css:css`
            display: flex;
            gap: 5px;
            width: 100%;
            margin-bottom: 0px;
            align-items: center;
        `
    },
    imageWrapper:{
        css:css`
            width: 65px;
            min-width: 65px;
            img{
            width: 65px;
            max-width: 65px;
            }
        `
    },
    sectionTitleWrapper:{
        css:css`
            
        `
    },
    infoCardWrapper:{
        css:css`
            height: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            gap: 18px;
            padding: 20px;
            width: 100%;
            position: relative;
            padding-bottom: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 15px;
                            padding-bottom: 25px;
                        `,
                        css`
                            padding: 15px;
                            padding-bottom: 25px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    },
    sectionTitle:{
        css:css`
            font-size: 0.8rem;
            font-weight: 600;
        `
    },
    iconSubTitle:{
        css:css`
        font-size: 0.9rem; 
        `
    },
    secondaryIcon:{
        css:css`
            width: 30px;
            position: absolute;
            right: 10px;
            bottom: 10px;
            height: 30px;
        `
    },
    mappedInfoCardsWrapper:{
        css:css`
            padding: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: 0px;
                        `,
                        css`
                            padding-bottom: 0px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    },
};

const styles = infoCardsStyles;

const DescriptionWrapper = styled.div`
    height: 100%;
`;

const InfoCards: React.FC<Props> = ({ id, infoCardTitle, 
        titleColor,
        primarySectionWidth,
        mappedInfoCards
         }) => {

    const cardItems = JSON.parse(JSON.stringify(mappedInfoCards))

    return (
        <>
            <StyledWrapper >
                <StyledWrapper {...styles.infocardcontainer}>
                    <GridContainer>
                        <GridItem width={12} {...styles.infoCardTitle}>
                            {infoCardTitle ? (
                                <Typography 
                                    as="h2"
                                    data-test-selector="infoCardTitle"
                                    style={{
                                        color: titleColor
                                    }}  
                                >{infoCardTitle}</Typography>
                            ) : null}
                        </GridItem>
                    </GridContainer>
                    {mappedInfoCards?.length > 0 ? (
                        <GridContainer {...styles.container}>
                            {mappedInfoCards?.map((card, index) => (
                                <GridItem  key={index} {...styles.sectionTitleGrid}  width={[12, 12, primarySectionWidth, primarySectionWidth, primarySectionWidth]}>
                                    <StyledWrapper 
                                        data-test-selector="sectionTitleWrapper"
                                        {...styles.infoCardWrapper}
                                        style={{
                                            backgroundColor: card.primaryBackground }}  
                                        >
                                        {card?.sectionTitle && (
                                            <Typography 
                                                data-test-selector="customFlyTitle"
                                                as="p"
                                                style={{ 
                                                    fontSize:`${card.textSize}rem`,
                                                    color: `${card.textColor}`,
                                                 }}  
                                            >
                                                {card.sectionTitle}
                                            </Typography>
                                        )}

                                        {card?.matrics.map((item, ind) => {
                                            return <StyledWrapper key={ind} {...styles.textIconWrapper}>
                                                        <StyledWrapper {...styles.imageWrapper}>
                                                                {item?.fields?.matricsTitle && <Typography 
                                                                  style={{
                                                                     color: item?.fields?.matricsColor,
                                                                     fontSize: "0.8rem",
                                                                     fontWeight: 600
                                                                    }}  
                                                                >{item.fields?.matricsTitle}</Typography>}
                                                            </StyledWrapper>
                                                        <StyledWrapper 
                                                        {...styles.textWrapper}  
                                                        >
                                                            {item?.fields?.matricsValue && <Typography 
                                                            style={{  
                                                                color: `${item?.fields?.matricsValueColor}`,
                                                                width: `${item?.fields?.matricsPercentage}%`,
                                                                backgroundColor: `${item?.fields?.matricsColor}`,
                                                                boxSizing: "border-box",
                                                                padding:"10px 8px",
                                                                fontSize: "0.8rem",
                                                                fontWeight: 600
                                                              }}  
                                                            
                                                             >{item.fields?.matricsValue}</Typography>}
                                                        </StyledWrapper>
                                            </StyledWrapper>
                                        }
                                        )}
                                        {card?.subTitle && (
                                            <Typography 
                                                style={{
                                                    color: card.textColor ? card.textColor : "black",
                                                    marginTop: "15px"
                                                }}  
                                            >
                                                {parse(card.subTitle, parserOptions)}
                                            </Typography>
                                        )}

                                    </StyledWrapper>
                                </GridItem>
                            ))}
                        </GridContainer>
                    ) : null}
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const membersList: WidgetModule = {
    component: connect(mapStateToProps)(InfoCards),
    definition: {
        group: "Basic",
        icon: "presentation-screen",
        fieldDefinitions: [
            {
                name: fields.matricsCards,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.sectionTitle;
                },
                defaultValue: [],
                fieldType: "Translatable",

                sortOrder: 2,
                fieldDefinitions: [
                    {
                        name: fields.sectionTitle,
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        sortOrder: 0,
                    },
                    {
                        name: fields.textSize,
                        displayName: "Title Font size",
                        editorTemplate: "TextField",
                        defaultValue: "1.6",
                        sortOrder: 4,
                    },
                    {
                        name: fields.textColor,
                        displayName: "Title Colour",
                        editorTemplate: "ColorPickerField",
                        defaultValue: "black",
                        sortOrder: 4,
                    },
                    {
                        name: fields.primaryBackground,
                        displayName: "Primary Background",
                        editorTemplate: "ColorPickerField",
                        defaultValue: "white",
                        sortOrder: 4,
                    },
                    {
                        name: fields.subTitle,
                        displayName: "Sub Title",
                        editorTemplate: "RichTextField",
                        defaultValue: "",
                    },
                    {
                        name: fields.subtitleColor,
                        displayName: "Subtitle Colour",
                        editorTemplate: "ColorPickerField",
                        defaultValue: "white",
                    },
                    {
                        name: fields.matrics,
                        editorTemplate: "ListField",
                        getDisplay: (item: HasFields) => {
                            return item?.fields?.matricsTitle || "Matrics";
                        },
                        defaultValue: [],
                        fieldDefinitions:[
                            {
                                name: fields.matricsColor,
                                displayName: "Matrics Colour",
                                editorTemplate: "ColorPickerField",
                                defaultValue: "black",
                            },
                            {
                                name: fields.matricsTitle,
                                displayName: "Matrics Title",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: fields.matricsValue,
                                displayName: "Matrics Value",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: fields.matricsValueColor,
                                displayName: "Matrics Value Colour",
                                editorTemplate: "ColorPickerField",
                                defaultValue: "white",
                            },
                            {
                                name: fields.matricsPercentage,
                                displayName: "Matrics percentage",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                        ]
                    }
                    
                ],
            },
            {
                name: fields.infoCardTitle,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 0,
                fieldType: "Translatable",
            },
            {
                fieldType: "Translatable",
                name: fields.titleColor,
                displayName: "Title color",
                editorTemplate: "ColorPickerField",
                defaultValue: "black",
                sortOrder: 1,
            },
            {
                name: fields.primarySectionWidth,
                displayName: "Section width",
                editorTemplate: "TextField",
                defaultValue: "3",
                sortOrder: 2,
                fieldType: "Translatable",
            },
        ],
    },
};

export default membersList;
